import { AbilityBuilder, PureAbility } from '@casl/ability';
import { PROCESSED_FLUID_REGIONS } from '../../../../constants/region-utils';
import Region from '../../../../constants/region';
import { ManageProcessedFluidsAdjustments } from '../../../../custom-widgets/PermissionsSelector/config/permissions';

const ADJUSTMENT_REGIONS = [Region.PRAIRIE, Region.UDA, Region.IMP, Region.DEMO];
const HIDE_PICKUP_FROM_DESTINATION_REGIONS = [Region.PRAIRIE];

function ProcessedFluidPermissions(user) {
    const { can, cannot, rules } = new AbilityBuilder(PureAbility);
    const {
        role,
        data: { region, id, processor_id, hauling_id, permissions },
    } = user;

    // IMP requires users to have the ManageProcessedFluidsAdjustments permission to mutate adjustments
    const hasMutatePermission = permissions.includes(ManageProcessedFluidsAdjustments.value);
    const allowAdjustmentMutations = region !== Region.IMP || hasMutatePermission;

    if (role === 'admin') {
        if (allowAdjustmentMutations) {
            can('mutate', 'adjustment');
        }
        can('mutate', 'pickup');
        can('mutate', 'dropoff');
    }

    // Can Create Pickup if origin plant or subuser of origin plant
    can('mutate', 'pickup', { 'origin_processor_id._id': id });
    can('mutate', 'pickup', { 'origin_processor_id._id': processor_id });

    // Haulers can create/mutate their dropoffs and pickups
    if (role === 'transport') {
        can('mutate', 'pickup', { 'hauling_id._id': id });
        can('mutate', 'pickup', { 'hauling_id._id': hauling_id });
        can('mutate', 'dropoff', { 'hauling_id._id': id });
        can('mutate', 'dropoff', { 'hauling_id._id': hauling_id });
    }

    // Can Create Dropoff if destination plant or subuser of destination plant
    can('mutate', 'dropoff', { 'destination_processor_id._id': id });
    can('mutate', 'dropoff', { 'destination_processor_id._id': processor_id });

    // Everyone can view pickups and dropoffs by default
    can('view', 'pickup');
    can('view', 'dropoff');

    if (ADJUSTMENT_REGIONS.includes(region)) {
        can('view', 'adjustment');

        // Can mutate adjustment if destination plant or subuser of destination plant
        if (allowAdjustmentMutations) {
            can('mutate', 'adjustment', { 'destination_processor_id._id': id });
            can('mutate', 'adjustment', { 'destination_processor_id._id': processor_id });
        }

        if (HIDE_PICKUP_FROM_DESTINATION_REGIONS.includes(region)) {
            // If logged in as the route session destination, cannot view a pickup
            cannot('view', 'pickup', { 'destination_processor_id._id': id, dropoff_id: null });
            cannot('view', 'pickup', { 'destination_processor_id._id': processor_id, dropoff_id: null });
        }
    }

    if (PROCESSED_FLUID_REGIONS.includes(region)) {
        can('view', 'new_processed_fluids');
    }

    return rules;
}

export default ProcessedFluidPermissions;
